function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 11.7817C0 4.51321 6.13595 0.264893 11.0921 0.264893C14.5371 0.264893 18.0303 1.39748 18.0303 3.47388C18.0303 4.41883 17.3697 5.17388 16.2371 5.17388C14.5843 5.17388 14.3022 4.13568 13.736 2.29411C13.3584 1.11433 12.6034 0.689612 11.1393 0.689612C7.6 0.689612 4.62584 3.3795 4.62584 11.0267C4.62584 18.9559 7.64719 22.2604 11.9888 22.2604C14.773 22.2604 16.6618 21.1739 18.0303 19.5222L18.2663 19.8053C16.8034 21.6458 14.3966 23.0155 10.9506 23.0155C5.09775 23.0155 0 18.7199 0 11.7817Z",
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.6312 22.3545C21.4727 21.8826 21.5199 21.1275 21.5199 15.4635V10.1298C21.5199 4.27698 21.5199 4.22979 19.584 3.99383V3.61631L25.9559 0.123047V5.55114L27.6087 3.75788C30.0154 1.11518 31.0065 0.359002 32.7536 0.359002C34.2154 0.359002 34.8289 1.11518 34.8289 2.24664C34.8289 3.52192 34.0739 4.1826 32.9896 4.1826C31.4312 4.1826 30.8177 2.86125 29.7323 2.86125C29.0233 2.86125 28.693 3.19159 27.6087 4.32417L25.9559 6.11743V15.4635C25.9559 21.1275 26.0031 21.8826 28.0806 22.3545V22.6848H19.6312V22.3545Z",
  fill: "white"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.0374 6.92044H48.9958C48.6654 2.57774 47.0149 0.642909 44.3711 0.642909C42.1992 0.642909 39.934 2.2474 39.0374 6.92044ZM34.0812 11.4991C34.0812 3.9474 40.0756 0.265381 44.3711 0.265381C49.2789 0.265381 52.3003 3.19122 53.0093 7.34516H38.943C38.7542 8.47774 38.6598 9.79909 38.6598 11.262C38.6598 18.7665 41.8228 22.307 46.4003 22.307C49.043 22.307 50.7902 21.5047 52.4419 20.2305L52.6789 20.5609C51.0261 21.8822 48.8542 23.062 45.4093 23.062C39.7924 23.062 34.0812 19.4755 34.0812 11.4991Z",
  fill: "white"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M56.5912 5.92902C55.08 1.77509 54.6553 1.35037 53.5238 0.972843V0.689697H61.2171V0.972843C59.8474 1.2088 59.6586 1.82228 61.0744 5.78745L65.3227 17.729L68.8159 9.37397L67.589 5.92902C66.0777 1.77509 65.653 1.39756 64.5687 0.972843V0.689697H72.1665V0.972843C70.7991 1.2088 70.5159 1.86947 71.8834 5.78745L76.0373 17.3987L79.9553 6.82565C81.8429 1.7279 80.9463 1.2088 79.0575 0.972843V0.689697H84.1553V0.972843C82.7867 1.35037 82.3631 1.63352 80.4744 6.82565L74.5272 22.9212H73.7249L69.0519 10.0358L63.5766 22.9212H62.7744L56.5912 5.92902Z",
  fill: "white"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M84.2915 0.217773H99.254V23.0155H84.2915V0.217773Z",
  fill: "white"
});
var _ref7 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_2230_2008)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M96.4218 18.4841C96.4218 15.9829 94.8645 14.7088 91.0421 13.1504C86.9353 11.4987 84.6218 9.75261 84.6218 6.11777C84.6218 2.57845 87.4072 0.217773 91.3724 0.217773C94.7702 0.217773 95.3364 1.39755 96.8005 1.39755C97.178 1.39755 97.4612 1.02114 97.6027 0.595302H97.9803V5.74025H97.6027C96.4218 2.10541 94.5342 0.642493 91.3724 0.642493C88.4926 0.642493 87.1713 1.86946 87.1713 4.08856C87.1713 6.40092 88.8702 7.39193 92.3634 8.76159C96.9421 10.6492 99.2544 12.4425 99.2544 16.3133C99.2544 20.2773 96.0915 23.0155 91.7027 23.0155C87.7848 23.0155 86.8409 21.3167 85.5196 21.3167C85.0949 21.3167 84.8117 21.5987 84.7173 22.1189H84.2915V15.7459H84.669C85.7084 20.3245 88.0679 22.5908 91.7027 22.5908C95.478 22.5908 96.4218 20.656 96.4218 18.4841Z",
  fill: "white"
}));
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 24,
    viewBox: "0 0 100 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2230_2008",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 0,
    width: 16,
    height: 24
  }, _ref6), _ref7);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.330614bc7a6f431660925d36ce4605fb.svg";
export { ForwardRef as ReactComponent };